class BaoProductFourSixty extends HTMLElement {
  connectedCallback () {
    // Create a new script element
    const script = document.createElement('script')

    // Get attributes from the custom element and set them on the script
    script.src = '//foursixty.com/media/scripts/fs.slider.v2.5.js'
    script.dataset.feedId = this.getAttribute('data-feed-id')
    script.dataset.theme = this.getAttribute('data-theme')
    script.dataset.connectorFilter = this.getAttribute('data-connector-filter')
    script.dataset.cellSize = this.getAttribute('data-cell-size')
    script.dataset.forUrl = this.getAttribute('data-for-url')

    this.appendChild(script)

    const makeScrollableAccessible = () => {
      const timeline = this.querySelector('.fs-timeline')
      if (timeline && !timeline.hasAttribute('tabindex')) {
        const ariaLabel = this.getAttribute('data-aria-label') || 'Social media feed'
        timeline.setAttribute('tabindex', '0')
        timeline.setAttribute('role', 'region')
        timeline.setAttribute('aria-label', ariaLabel + ' - use arrow keys to scroll, Enter or Space to open post when focused')
      }
    }

    const makePostsFocusable = () => {
      const entries = this.querySelectorAll('.fs-timeline-entry')
      entries.forEach((entry) => {
        entry.setAttribute('tabindex', '0')
      })
    }

    const getFirstVisiblePost = () => {
      const timeline = this.querySelector('.fs-timeline')
      if (!timeline) return null
      const rect = timeline.getBoundingClientRect()
      const entries = this.querySelectorAll('.fs-timeline-entry')
      for (const entry of entries) {
        if (entry.getAttribute('aria-hidden') === 'true') continue
        const entryRect = entry.getBoundingClientRect()
        if (entryRect.left < rect.right && entryRect.right > rect.left) return entry
      }
      return entries[0] || null
    }

    const setupKeyboardHandling = () => {
      if (this._keydownHandler) return
      this._keydownHandler = (e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return
        const active = document.activeElement
        const post = active?.closest('.fs-timeline-entry')
        const isTimeline = active?.classList?.contains('fs-timeline')
        if (!post && !isTimeline) return
        e.preventDefault()
        const toOpen = post || getFirstVisiblePost.call(this)
        if (toOpen) toOpen.click()
      }
      this.addEventListener('keydown', this._keydownHandler, true)
    }

    const scriptLoadCallback = () => {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList') {
            makeScrollableAccessible()
            makePostsFocusable()
            requestAnimationFrame(() => makePostsFocusable())
            setupKeyboardHandling()
            if (this.itemCount > 1) {
              const section = document.getElementById(this.getAttribute('data-section-id'))

              if (this.itemCount > 3) {
                section.classList.add('fs-require-arrows')
              }

              this.printNumberOfItems()

              section.classList.remove('hidden')
            }
          }
        })
      })

      observer.observe(this, {
        childList: true,
        subtree: true,
      })
      makeScrollableAccessible()
      makePostsFocusable()
      setupKeyboardHandling()
      requestAnimationFrame(() => {
        makePostsFocusable()
      })
    }

    script.addEventListener('load', scriptLoadCallback)
  }

  printNumberOfItems () {
    this.style.setProperty('--Item_Count', this.itemCount)

    if (this.itemCount > 3) {
      this.style.setProperty('--Item_Count', 3)
    }
  }

  get itemCount () {
    return this.querySelectorAll('.fs-entry-container').length
  }
}

if (!customElements.get('bao-product-four-sixty')) {
  customElements.define('bao-product-four-sixty', BaoProductFourSixty)
}
